import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceEditUnavailabilityNotificationState = createStateReducer(
  initialState,
  {
    [events.editUnavailabilitySucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editUnavailability",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editUnavailabilityFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editUnavailability",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceEditUnavailabilityNotificationState };
